import { Pagination } from '@/domain/entities/Pagination'

export class TrainingMaterialData {
  public id: number
  private categoryId: number
  public title: string
  private file: Object
  public isRecommended: boolean
  public Owner: string
  private imageThumbnail: string
  private createdAt: string
  private updatedAt: string
  private expireddate: string

  constructor(
    id: number,
    categoryId: number,
    title: string,
    file: Object,
    isRecommended: boolean,
    Owner: string,
    imageThumbnail: string,
    createdAt: string,
    updatedAt: string,
    expireddate: string
  ) {
    this.id = id
    this.categoryId = categoryId
    this.title = title
    this.file = file
    this.isRecommended = isRecommended
    this.Owner = Owner
    this.imageThumbnail = imageThumbnail
    this.createdAt = createdAt
    this.updatedAt = updatedAt
    this.expireddate = expireddate
  }
}

export class TrainingMaterial {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: TrainingMaterialData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: TrainingMaterialData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}
